export default [{
	titulo: 'Status',
	icone: 'menu-icon fa fa-caret-right',
	url: '/admin/status',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]